import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetUpdateTableXMLTableData: '[GetUpdateTableXMLTableData] Action',
  SetUpdateTableXMLData: '[SetUpdateTableXMLData] Action',
  GetUpdateTableXMLTranslateData: '[GetUpdateTableXMLTranslateData] Action',
}

const initialUpdateTableXMLState: IUpdateTableXMLState = {
  updateTableXMLColumnList: [],
  updateTableXMLColumnValues: [],
  updateTableXMLDefinitions: [],
  updateTableXMLDe: [],
  updateTableXMLEn: []
}

export interface IUpdateTableXMLState {
  updateTableXMLColumnValues: [],
  updateTableXMLColumnList: [],
  updateTableXMLDefinitions: [],
  updateTableXMLDe: [],
  updateTableXMLEn: []
}

export const reducer = persistReducer(
  { storage, key: 'portal-UpdateTableXML', whitelist:  [ ] },
  (state: IUpdateTableXMLState = initialUpdateTableXMLState, action: any) => {
    switch (action.type) {
      case actionTypes.GetUpdateTableXMLTableData: {
        const updateTableXMLColumnValues = action.payload.data.tablexml;
        let headers = JSON.parse(action.payload.data.headers);
        let updateTableXMLDefinitions = JSON.parse(action.payload.data.definitions);
        let updateTableXMLColumnList: any = [];
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          updateTableXMLColumnList.push(newElement[0]);
        });
        return { ...state, updateTableXMLColumnList, updateTableXMLColumnValues, updateTableXMLDefinitions};
      }
    
      case actionTypes.SetUpdateTableXMLData: {
        const updateTableXMLColumnValues = action.payload.data;
        return { ...state, updateTableXMLColumnValues };
      }

      case actionTypes.GetUpdateTableXMLTranslateData: {
        const updateTableXMLDe = JSON.parse(action.payload.data.de);
        const updateTableXMLEn = JSON.parse(action.payload.data.en);
        return { ...state, updateTableXMLDe, updateTableXMLEn };
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  getUpdateTableXMLTableData: (data: any) => ({ type: actionTypes.GetUpdateTableXMLTableData, payload: { data } }),
  getTranslateData: (data: any) => ({ type: actionTypes.GetUpdateTableXMLTranslateData, payload: { data } }),
  setUpdateTableXMLData: (data: any) => ({ type: actionTypes.SetUpdateTableXMLData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
